import * as idValidatorTypes from './idValidatorTypes';
import { SWITCH_TO_VIEW } from '../../../../constants/constants';

const initialState = {
  idDocumentList: [],
  serviceTypeList: [],
  selectedIdDoc: null,
  selectedServiceType: null,
  enableServiceSpinner: false,
  response: undefined,
  pollingQueuePayload: {
    searchText: '',
    sortDirection: 'desc', // (asc, desc)
    sortColumn: 'CreatedDate', // (ClientRefernceID, CreatedDate, Status)
    pageNumber: 1,
    pageSize: 5,
  },
  pollingQueueResponse: undefined,
  pollingDetailResponse: undefined,
  manualRequestResult: undefined,
  switchToView: SWITCH_TO_VIEW.dashboard,
  filePlacement: undefined,
  isUploadError: false
};

const idValidatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case idValidatorTypes.GET_ID_DOCUMENTLIST:
      return { ...state, idDocumentList: action.payload.idDocumentList };
    case idValidatorTypes.RESET_IDVALIDATOR_STATE:
      return {
        ...state,
        selectedIdDoc: null,
        selectedServiceType: null,
        enableServiceSpinner: false,
        response: undefined,
        switchToView: SWITCH_TO_VIEW.dashboard,
      };
    case idValidatorTypes.SET_SELECTED_ID_DOC:
      return { ...state, selectedIdDoc: action.data.target.value };
    case idValidatorTypes.SET_SELECTEDTYPE_STATE:
      return { ...state, selectedServiceType: action.data.target.value };
    case idValidatorTypes.ENABLE_SERVICE_SPINNER:
      return { ...state, enableServiceSpinner: action.enableServiceSpinner };
    case idValidatorTypes.SET_VALIDATE_RESPONSE:
      return { ...state, response: action.data };
    case idValidatorTypes.GET_SERVICE_TYPES:
      return { ...state, serviceTypeList: action.payload.messages };
    case idValidatorTypes.DELETE_UPLOAD_FILE:
      return {...state, filePlacement: action.fileplacement, isUploadError: true};
    case idValidatorTypes.RESET_UPLOAD_FILE:
      return {...state, filePlacement: undefined, isUploadError: false};
    case idValidatorTypes.RESET_POLLINGQUEUE_STATE:
      return { ...state, enableServiceSpinner: false, manualRequestResult: undefined, switchToView: SWITCH_TO_VIEW.pollingQueue };
    case idValidatorTypes.SET_POLLING_QUEUE_PAYLOAD:
      return { ...state, pollingQueuePayload: action.payload };
    case idValidatorTypes.SET_POLLING_QUEUE_RESPONSE:
      return { ...state, pollingQueueResponse: action.response };
    case idValidatorTypes.SET_POLLING_DETAIL_RESPONSE:
      return { ...state, pollingDetailResponse: action.response };
    case idValidatorTypes.SET_MANUAL_REQUEST_RESULT:
      return { ...state, manualRequestResult: action.response };

    case idValidatorTypes.SET_SWITCH_TO_VIEW:
      return { ...state, switchToView: action.switchToView };
    default:
      return state;
  }
};

export { initialState };
export default idValidatorReducer;
